import VueRouter from 'vue-router'
import Launch from '@/views/launchList/index.vue'
import Bill from '@/views/billManagement/index.vue'
import DashBoard from '@/views/dashboard/index.vue'
import Login from '@/views/login/index.vue'
import Register from '@/views/register/index.vue'
import Agreement from '@/views/agreement/index.vue'
import ApplySettlement from "@/views/billManagement/components/applySettlement.vue"
import SettlementDetails from "@/views/billManagement/components/settlementDetails.vue"
import UserCenter from '@/views/userCenter/index.vue'
import PassWord from '@/views/changePassWord/index.vue'
import Home from "@/views/Home/index.vue"
var router = new VueRouter({
  // 配置路由骨子额
  mode: 'hash',
  routes: [
    { path: '/', redirect: "/dosh" },
    { path: "/dosh", component: Home },
    { path: '/login', component: Login },
    { path: '/register', component: Register },
    { path: '/agreement', component: Agreement },
    {
      path: '/userCenter',
      component: UserCenter,
    },
    {
      path: '/changePassWord',
      component: PassWord,
    },
    {
      path: '/launchList',
      component: Launch,
    },
    {
      path: '/bill',
      component: Bill,
    },
    {
      path: '/applysettlement',
      component: ApplySettlement,
    },
    {
      path: "/settlementdetails",
      component: SettlementDetails,
    },
    {
      path: '/home',
      component: DashBoard,
    },

  ],
  linkActiveClass: 'mui-active'
})
export default router
